module.exports = __webpack_public_path__ + "static/media/hoteless-200x200.952886a5.png";